export default "__VITE_ASSET__DxyyJT5T__"